export default __webpack_public_path__ + "static/media/bolinhas8.114f7bfb.svg";